<!--
 * @Autor: yingna.gao
 * @Date: 2022-07-27 16:15:17
 * @LastEditTime: 2022-11-02 16:21:30
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/views/standard/business/components/CreateDialog.vue
-->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="$t('companyCenter.createBusiness')"
    v-bind="$attrs"
    :close-on-click-modal="false"
    destroy-on-close
    width="1000px"
  >
    <div class="dialog-around h-60">
      <create ref="formCreate"></create>
    </div>

    <span slot="footer" class="text-right">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="createOrg">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from "@/api/business";
import Create from "./create";

export default {
  name: "CreateDialog",
  components: { Create },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orgId: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    }
  },
  methods: {
    createOrg() {
      const { validate } = this.$refs.formCreate.getFormFunction();
      // 校验表单
      validate(valid => {
        if (valid) {
          const {
            tenantName,
            socialCreditCode,
            address,
            effect,
            cellphone,
            displayName,
            username,
            password,
            email,
            enterpriseStructure,
            adminMenuType,
            tenantSource
          } = this.$refs.formCreate.formData;
          const params = {
            tenantName,
            socialCreditCode,
            address,
            effect,
            tenantSource,
            adminMenuType,
            admin: { cellphone, displayName, username, password, email },
            enterpriseStructure
          };

          api.createOrg(params).then(
            res => {
              this.$message.success("租户创建成功");
              this.dialogVisible = false;
              this.$emit("success");
            },
            error => {
              // this.$message.error('创建组织失败');
              throw new Error(error);
            }
          );
        }
      });
    }
  }
};
</script>

<style lang="scss">
.dialog-around {
  display: flex;
  justify-content: space-around;
}
</style>
